import { defineMessages } from 'react-intl'

export default defineMessages({
  driversHeadline: {
    id: 'app.drivers.headline',
    defaultMessage: 'Driver',
  },
  driversAddDriverHeadline: {
    id: 'app.drivers.addriverHeadline',
    defaultMessage: 'Who was driving?',
  },
  driversNoDriver: {
    id: 'app.drivers.noDriver',
    defaultMessage: 'No Driver',
  },
  driversSomeoneElse: {
    id: 'app.drivers.someoneElse',
    defaultMessage: 'Someone else',
  },
  driversUploadDriversLicensePhoto: {
    id: 'app.drivers.uploadDriversLicensePhoto',
    defaultMessage: "Upload driver's license photo",
  },

  // Validation messages
  validationAddressRequired: {
    id: 'app.passenger.validation.addressRequired',
    defaultMessage: 'Address is required!',
  },
  validationPhoneRequired: {
    id: 'app.passenger.validation.phoneRequired',
    defaultMessage: 'Phone number is required!',
  },
  validationPolicyRequired: {
    id: 'app.otherVehicle.validation.policyRequired',
    defaultMessage: 'Policy is required!',
  },
  validationDriverLicenseRequired: {
    id: 'app.otherVehicle.validation.driverLicenseRequired',
    defaultMessage: 'Driver license is required!',
  },
  validationFirstNameRequired: {
    id: 'app.passenger.validation.firstNameRequired',
    defaultMessage: 'First name is required!',
  },
  validationLastNameRequired: {
    id: 'app.passenger.validation.lastNameRequired',
    defaultMessage: 'Last name is required!',
  },

  // Placeholder messages
  placeholderFirstName: {
    id: 'app.passenger.placeholder.firstName',
    defaultMessage: 'First name',
  },
  placeholderLastName: {
    id: 'app.passenger.placeholder.lastName',
    defaultMessage: 'Last name',
  },
  placeholderPolicy: {
    id: 'app.otherVehicle.placeholder.policy',
    defaultMessage: 'Policy #',
  },
  placeholderDriverLicense: {
    id: 'app.otherVehicle.placeholder.driverLicense',
    defaultMessage: 'Driver License #',
  },
  placeholderPhoneNumber: {
    id: 'app.passenger.placeholder.phoneNumber',
    defaultMessage: 'Phone #',
  },
  placeholderAdress: {
    id: 'app.passenger.placeholder.address',
    defaultMessage: 'Address',
  },
})
